<ng-container *ngIf="isVisible">
    <div [ngClass]="field.panelClass" [id]="field.id + '-container'">
        <mat-form-field class="full-width" [ngClass]="{ required: isRequired }">
            <mat-label *ngIf="field.label">{{ field.label | translate }}</mat-label>
            <input
                matInput
                [id]="field.id"
                [attr.formcontrolname]="field.name"
                [placeholder]="fieldUtils.getPlaceholder(field)"
                [value]="control.value | date : field.dateFormat || fallbackDateFormat"
                tabindex="-1"
                class="datepickerStyles"
                [disabled]="control.disabled"
                appDatetimepickerPosition
                [matDatetimepickerComp]="datePickerControl"
                (input)="dateInput($event)"
                (change)="dateChange($event)"
            />
            <input matInput hidden [formControl]="control" [matDatetimepicker]="datePickerControl" />
            <mat-datetimepicker-toggle
                matSuffix
                [for]="datePickerControl"
                [disabled]="control.disabled"
            ></mat-datetimepicker-toggle>
            <mat-datetimepicker
                #datePickerControl
                [timeInterval]="field.timeInterval || 1"
                [type]="field.datePickerType || 'date'"
            >
            </mat-datetimepicker>
        </mat-form-field>
        <div class="mat-error" *ngIf="hasError">
            <div *ngFor="let error of errorMessages">{{ error | translateSmart }}</div>
        </div>
    </div>
</ng-container>
